import { RootState } from "../root-reducer";

/**
 * A redux state selector meant to be used with useSelector(). The app's entire state is
 * passed in and this drills down to specifically the apiKey.
 *
 * @param state
 */
export function selectApiKey(state: RootState) {
    return state.appConfig.apiKey;
}
export function getApiKeyFIS(state: RootState) {
    return state.appConfig.apiKeyFIS;
}